import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Trash2, X, Save, MapPin, Pencil } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });

const turkishCities = ["Adana","Adıyaman","Afyonkarahisar","Ağrı","Amasya","Ankara","Antalya","Artvin","Aydın","Balıkesir","Bilecik","Bingöl","Bitlis","Bolu","Burdur","Bursa","Çanakkale","Çankırı","Çorum","Denizli","Diyarbakır","Edirne","Elazığ","Erzincan","Erzurum","Eskişehir","Gaziantep","Giresun","Gümüşhane","Hakkari","Hatay","Isparta","Mersin","İstanbul","İzmir","Kars","Kastamonu","Kayseri","Kırklareli","Kırşehir","Kocaeli","Konya","Kütahya","Malatya","Manisa","Kahramanmaraş","Mardin","Muğla","Muş","Nevşehir","Niğde","Ordu","Rize","Sakarya","Samsun","Siirt","Sinop","Sivas","Tekirdağ","Tokat","Trabzon","Tunceli","Şanlıurfa","Uşak","Van","Yozgat","Zonguldak","Aksaray","Bayburt","Karaman","Kırıkkale","Batman","Şırnak","Bartın","Ardahan","Iğdır","Yalova","Karabük","Kilis","Osmaniye","Düzce"];

export default function AdminMapPins() {
  const [pins, setPins] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ city: "", label: "", description: "", project_name: "", project_detail: "" });
  const [loading, setLoading] = useState(false);

  const load = () => axios.get(`${API}/api/map-pins`, { headers: getHeaders() }).then((r) => setPins(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ city: "", label: "", description: "", project_name: "", project_detail: "" }); setEditing("new"); };
  const openEdit = (p) => { setForm({ city: p.city, label: p.label, description: p.description || "", project_name: p.project_name || "", project_detail: p.project_detail || "" }); setEditing(p); };
  const close = () => setEditing(null);

  const handleSave = async () => {
    setLoading(true);
    try {
      if (editing === "new") await axios.post(`${API}/api/admin/map-pins`, form, { headers: getHeaders(), withCredentials: true });
      else await axios.put(`${API}/api/admin/map-pins/${editing.id}`, form, { headers: getHeaders(), withCredentials: true });
      close(); load();
    } catch { alert("Hata"); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu pini silmek istediğinize emin misiniz?")) return;
    await axios.delete(`${API}/api/admin/map-pins/${id}`, { headers: getHeaders(), withCredentials: true });
    load();
  };

  return (
    <div data-testid="admin-map-pins">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Harita Pinleri</h1>
        <button onClick={openNew} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors" data-testid="add-pin-btn">
          <Plus size={16} /> Yeni Pin
        </button>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {pins.map((pin) => (
          <div key={pin.id} className="bg-[#161923] border border-white/5 rounded-xl p-4" data-testid={`pin-${pin.id}`}>
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#FF5A00]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin size={16} className="text-[#FF5A00]" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm">{pin.city}</p>
                  <p className="text-slate-500 text-xs">{pin.label}</p>
                </div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => openEdit(pin)} className="p-2 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg"><Pencil size={14} /></button>
                <button onClick={() => handleDelete(pin.id)} className="p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg"><Trash2 size={14} /></button>
              </div>
            </div>
            {pin.project_name && <p className="text-slate-400 text-xs mt-1">Proje: {pin.project_name}</p>}
            {pin.project_detail && <p className="text-slate-600 text-xs mt-1">{pin.project_detail}</p>}
          </div>
        ))}
        {pins.length === 0 && <div className="col-span-full bg-[#161923] border border-white/5 rounded-xl p-12 text-center text-slate-500">Henüz harita pini eklenmedi</div>}
      </div>

      {editing !== null && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="pin-modal">
          <div className="bg-[#1a1d27] border border-white/10 rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-5 border-b border-white/5">
              <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Outfit" }}>{editing === "new" ? "Yeni Pin" : "Pin Düzenle"}</h2>
              <button onClick={close} className="text-slate-400 hover:text-white"><X size={20} /></button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Şehir</label>
                <select value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="admin-input" data-testid="form-pin-city">
                  <option value="">Şehir seçin</option>
                  {turkishCities.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Etiket</label>
                <input type="text" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} className="admin-input" placeholder="Örn: Konut Projesi" data-testid="form-pin-label" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Proje Adı</label>
                <input type="text" value={form.project_name} onChange={(e) => setForm({ ...form, project_name: e.target.value })} className="admin-input" data-testid="form-pin-project" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Proje Detayı</label>
                <textarea value={form.project_detail} onChange={(e) => setForm({ ...form, project_detail: e.target.value })} rows={3} className="admin-input resize-none" data-testid="form-pin-detail" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Kısa Açıklama</label>
                <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={2} className="admin-input resize-none" data-testid="form-pin-description" />
              </div>
            </div>
            <div className="flex justify-end gap-3 p-5 border-t border-white/5">
              <button onClick={close} className="px-4 py-2 rounded-lg text-sm text-slate-400 hover:text-white border border-white/10 transition-colors">İptal</button>
              <button onClick={handleSave} disabled={loading || !form.city || !form.label} className="flex items-center gap-2 px-4 py-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white rounded-lg text-sm font-semibold transition-colors disabled:opacity-50" data-testid="form-pin-save">
                <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
